module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.$root.confirm.isVisible),
      callback: function($$v) {
        _vm.$root.confirm.isVisible = $$v
      },
      expression: "$root.confirm.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$root.confirm.title))])], 1), _vm._v(" "), _c('v-flex', [_c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.$root.confirm.question)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmed(true)
      }
    }
  }, [_vm._v("\n        כן\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmed(false)
      }
    }
  }, [_vm._v("\n        לא\n        ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eec6906"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopupConfim.vue
// module id = 906
// module chunks = 2